import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Table, Input, Space, Button, Checkbox, Form, List ,Flex} from "antd";
import React, { useState, useRef, useEffect } from "react";
import { LayoutData } from "../Structur/Aconlayout";
import { IntToBetrag } from "../Helper/ZahlenFormat";
import { DelphiDatumShow } from "../Helper/DateTimeHelper";
import { PrinterOutlined } from "@ant-design/icons";
import {KontenDatenJournalPdf} from "./KontenDatenJournalPdf";

export const KontenDatenJournal = ({ kontoData, setTitel }) => {
  const { user, logoutLogin, apiBaseUrl } = LayoutData();
  const [url1, setUrl1] = useState("");
  const [dataSource, setDataSource] = useState();
  const [showProfiAuswahl, setShowProfiAuswahl] = useState(false);
  const [aktSaldo,setAktSaldo]= useState(0);


  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    if (apiBaseUrl) {
      setUrl1(
        `${apiBaseUrl}profi/getprfibujournal?aktJahr=${kontoData.jahr}&aktKonto=${kontoData.konto}`
      );
    }
    setTitel(
      <>
        {kontoData.Suchbeg}
        <br />
        <Flex justify="space-between">
        <b>{IntToBetrag(kontoData.konto)}</b>
        <b>Saldo: {IntToBetrag(aktSaldo)}</b>
        <Button
          icon={<PrinterOutlined style={{ fontSize: 17 }} />}
          onClick={handleDruckBtnClick}
        />
        </Flex>
      </>
    );
  }, [apiBaseUrl, kontoData,aktSaldo]);

  const {
    isPending: isPending1,
    error: error1,
    data: journaldata,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) =>  {
          if (res.status === 401) logoutLogin();
          if (!res.ok) {
            throw new Error('XXX Network response was not ok');
          }
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        console.error("XXX Error url1", url1);
        return [];//Promise.resolve({});
      }
    },
  });
  if (error1) {
    console.error("XXX Error1", error1);
    //logout();
  }

  useEffect(() => {
    if (journaldata && Array.isArray(journaldata)) {
      //console.log("XXX personenData", personenData);
//try{
      const newData = journaldata.map((item, index) => ({
        ...item,
        key: index,
      }));
      let summeSoll = 0;
      let summeHaben = 0;
      newData.map((item, index) => {
        summeSoll += item.soll;
        summeHaben += item.haben;
        return null;
      });
     setAktSaldo(summeSoll - summeHaben);

      //checkMainContainerHeight();
      setDataSource(newData);
    /*}
      catch(error){
        console.error("XXX Error2", error);
      }*/
    }
  }, [journaldata]);

  const getColumns = () => {
    return [
      {
        title: "Datum\nBeleg",
        dataIndex: "datum",
        key: "datum",
        align: "right",
        render: (datum, record) => (
          <>
            <b>
              <DelphiDatumShow delphiDatum={datum} />
            </b>
            <br />
            {record.beleg}{" "}
          </>
        ),
      },
      {
        title: "Buchungstext",
        dataIndex: "Butext",
        key: "butext",
        render: (text) => <>{text}</>,
      },
      {
        title: "Soll-Haben",
        dataIndex: "soll",
        key: "soll",
        align: "right",
        render: (soll, record) => <>{IntToBetrag(soll - record.haben)}</>,
      },
    ];
  };
  const handleDruckBtnClick = () => {

    setShowProfiAuswahl(true);

  };

  return (
    <>
      <Table
        size={"small"}
        dataSource={dataSource}
        columns={getColumns()}
        pagination={false}
       // footer={() => <>Saldo: {IntToBetrag(aktSaldo)}</>}
        summary={(pageData) => {         
          return (
            <>
              <Table.Summary.Row style={{color:"green"}}>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}><b>Eröffnung:</b></Table.Summary.Cell>
                <Table.Summary.Cell index={2}><div style={{textAlign:'right'}}><b>{IntToBetrag(kontoData.bilanzopen)}</b></div></Table.Summary.Cell>
              </Table.Summary.Row>
          
              <Table.Summary.Row style={{color:"green"}}>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={1}><b>Abschluss:</b></Table.Summary.Cell>
              <Table.Summary.Cell index={2}><div style={{textAlign:'right'}}><b>{IntToBetrag(kontoData.bilanzclose)}</b></div></Table.Summary.Cell>
            </Table.Summary.Row>
          </>
        );
        }}
      />
       <KontenDatenJournalPdf
        showProfiAuswahl={showProfiAuswahl}
        setShowProfiAuswahl={setShowProfiAuswahl}
        kontoData={kontoData}
        dataSource={dataSource}
        user={user}
      />
    </>
  );
};
